var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92039 3.57901H7.76478C7.85037 3.57901 7.92039 3.50899 7.92039 3.4234V3.57901H13.8336V3.4234C13.8336 3.50899 13.9036 3.57901 13.9892 3.57901H13.8336V4.9795H15.234V3.4234C15.234 2.73678 14.6758 2.17853 13.9892 2.17853H7.76478C7.07816 2.17853 6.51991 2.73678 6.51991 3.4234V4.9795H7.92039V3.57901ZM17.7238 4.9795H4.03015C3.68587 4.9795 3.40771 5.25765 3.40771 5.60194V6.22438C3.40771 6.30996 3.47774 6.37999 3.56332 6.37999H4.73818L5.21862 16.553C5.24974 17.2163 5.79827 17.7395 6.46155 17.7395H15.2924C15.9576 17.7395 16.5042 17.2182 16.5353 16.553L17.0158 6.37999H18.1906C18.2762 6.37999 18.3462 6.30996 18.3462 6.22438V5.60194C18.3462 5.25765 18.0681 4.9795 17.7238 4.9795ZM15.1426 16.339H6.61133L6.14061 6.37999H15.6133L15.1426 16.339Z",
    fill: "#E15656"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5cca0baa55b12f651079b18e5ffe01d1.svg";
export { ForwardRef as ReactComponent };